module.exports = __webpack_public_path__ + "static/footer-bg-e854b4f65bfe30d5b99492908bd34fc0.png";